<template>
  <v-card>
    <v-card-text>
      <h2>Group</h2>
      <template v-if="changeGroupStatus == 0">
        <router-link
          v-if="entity.group"
          class="groupName"
          :to="{ name: 'group', params: { id: entity.group.id } }"
          >{{ entity.group.name }}</router-link
        >
        <span v-if="!entity.group">Not set</span>
        &#160;
        <a @click="fetchGroups">change</a>
        <template v-if="entity.typeid == 8">
          <v-alert :value="hasGroupPanels" type="success">
            <div>This group has panel numbers</div>
            <div v-if="hasGroupPanels">
              <div
                v-for="groupPanel in entity.group.groupPanels"
                :key="groupPanel.id"
              >
                {{ groupPanel.panelno }}
              </div>
            </div>
          </v-alert>
          <v-alert :value="!hasGroupPanels" type="warning"
            >This group has no panel numbers</v-alert
          >
        </template>
      </template>
      <div class="ajaxForm" v-if="changeGroupStatus == 1">
        <v-select
          label="Choose group from list"
          v-model="groupid"
          :items="groups"
          item-value="id"
          item-text="name"
          outline
        />
        <v-btn @click="saveGroup">Save</v-btn>&#160;
        <v-btn @click="changeGroupStatus = 0">Cancel</v-btn>
        <router-link
          :to="{
            name: 'groupCreate',
            params: { id: entity.typeid },
            query: { entityid: $route.params.id }
          }"
          >Create new group</router-link
        >&#160;
        <a @click="deleteGroup" v-if="entity.group">Remove from group</a>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import TYPE_GROUPS from "@/graphql/directory/TypeGroups";
import UPDATE_ENTITY_GROUP from "@/graphql/directory/UpdateEntityGroup";
import DELETE_ENTITY_GROUP from "@/graphql/directory/DeleteEntityGroup";
export default {
  name: "Group",
  props: ["entity"],
  computed: {
    hasGroupPanels() {
      return (
        this.entity.group &&
        this.entity.group.groupPanels &&
        this.entity.group.groupPanels.length > 0
      );
    }
  },
  data() {
    return {
      changeGroupStatus: 0,
      groups: [],
      groupid: null
    };
  },
  methods: {
    async fetchGroups() {
      if (this.entity.group) {
        this.groupid = this.entity.group.id;
      }
      const response = await this.$apollo.query({
        query: TYPE_GROUPS,
        variables: { id: this.entity.typeid }
      });
      // console.log(response.data);
      this.groups = response.data.type.groups;
      this.changeGroupStatus = 1;
    },
    async saveGroup() {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_GROUP,
        variables: {
          id: Number(this.$route.params.id),
          groupid: this.groupid
        }
      });
      // console.log(response.data);
      this.$emit("triggerUpdate");
      this.changeGroupStatus = 0;
    },
    async deleteGroup() {
      await this.$apollo.mutate({
        mutation: DELETE_ENTITY_GROUP,
        variables: {
          id: Number(this.$route.params.id)
        }
      });
      // console.log(response.data);
      this.$emit("triggerUpdate");
      this.changeGroupStatus = 0;
    }
  }
};
</script>
